import React from 'react';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Aula from 'Interface/Aulas';
import { useRemoverAulaMutation } from 'View/Service/Default/Aulas';

interface Props {
  dados: Aula;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerAula] = useRemoverAulaMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerAula(dados).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <div className="fs-4">
        <a
          href={dados.url}
          className={`text-decoration-none ${!dados.url && 'disabled'}`}
          target="_blank"
          rel="noreferrer"
        >
          {dados.titulo}
          <small className="d-block fs-6 text-muted">{dados.descricao}</small>
        </a>
      </div>
      <div className="ms-5 fs-5 flex-grow-1 text-end">
        <Botao
          icone="trash"
          tema="danger"
          className="ms-2"
          confirmacao="Você tem certeza que deseja remover essa aula? Essa ação é irreversivel."
          onClick={remover}
        />
      </div>
    </div>
  );
};

export default Lista;
